import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { esimApi } from './esimApi';

class ESIMDetail extends Component {
    state = {
        countryDetails: {},
        selectedCountry: null,
        isLoading: false,
        showAllcountries: false
    }

    getCountryKey = () => {
        const { country } = this.props.match.params;
        return country;
    }

    // getSelectedCountry = () => {
    //     const { countryDetails, selectedCountry } = this.state;
    //     return selectedCountry || countryDetails[this.getCountryKey()] || countryDetails.Turkey;
    // }

    componentDidMount = () => {
        this.loadCountryPlans();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.country !== this.props.match.params.country) {
            this.loadCountryPlans();
        }
    }

    loadCountryPlans = async () => {
        const key = this.getCountryKey();
        this.setState({ isLoading: true, showAllcountries: false });

        try {
            const response = await esimApi.getDestinationPlans(key);
            const statusCode = Number(response?.status?.statusCode);

            if (statusCode !== 1) {
                this.setState({ isLoading: false, selectedCountry: null });
                this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(statusCode || 'unexpected error'));
                return;
            }

            const destination = response?.data || null;
            const plans = response?.data?.plans || [];

            const planItems = plans.map((plan, index) => ({
                id: plan.planId,
                volume: plan.title || '—',
                period: plan.validityDays || '—',
                note: plan.note || '',
                price: plan.priceCents ? this.formatPriceFromCents(plan.priceCents, plan.currency) : '—',
                tag: plan.tag || plan.badge || '',
                popular: plan.popular || false,
                networkType: plan.networkType || '',
            }));

            const alsoCoveredBy = response?.data?.alsoCoveredBy || [];
            const alsoCoveredByItems = alsoCoveredBy.map((item, index) => ({
                id: item.id,
                name: item.name || '—',
                code: item.code || '—',
                flagUrl: item.flagUrl || '🌍',
                countryCount: item.countryCount || '—',
                price: item.startingPriceCents ? this.formatPriceFromCents(item.startingPriceCents, item.currency) : '—'
            }));

            this.setState({
                selectedCountry: {
                    name: destination?.destinationName || key,
                    flagUrl: destination?.flagUrl || '🌍',
                    imageUrl: destination?.imageUrl || null,
                    networkInfo: destination?.networkInfo || null,
                    plans: planItems.length ? planItems : [],
                    alsoCoveredBy: alsoCoveredByItems.length ? alsoCoveredByItems : [],
                    countries: destination?.countries || [],
                    notices: destination?.notices || []
                },
                isLoading: false,
                topUpEsimId: this.props.match.params.topUpEsimId || null
            });
        } catch (error) {
            this.setState({ isLoading: false });
            this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t('unexpected error'));
        }
    }

    renderChevron = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M5.96655 2.72003L10.3132 7.0667C10.8266 7.58003 10.8266 8.42003 10.3132 8.93336L5.96655 13.28" stroke="#64748B" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )

    openOrderPage = (plan) => {
        const { selectedCountry } = this.state;

        this.props.history.push({
            pathname: `/dashboard/services/e-sim/order/${selectedCountry.name}/${plan.id}/${this.state.topUpEsimId || ''}`,
            state: {
                selectedCountry,
                selectedPlan: plan
            }
        });
    }

    togglecountries = () => {
        this.setState((prevState) => ({
            showAllcountries: !prevState.showAllcountries
        }));
    }

    formatPriceFromCents = (cents, currency) => {
        const value = Number(cents);

        if (!Number.isFinite(value) || value <= 0) {
            return '';
        }

        return `${(value / 100).toFixed(2)} ${currency}`;
    }

    render() {
        const { selectedCountry, showAllcountries } = this.state;
        const { t } = this.props;

        const countries = selectedCountry?.countries || [];
        const visiblecountries = showAllcountries
            ? countries
            : countries.slice(0, 14);
        const remainingcountries = countries.length > 14
            ? countries.length - 14
            : 0;

        return (
            <>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{this.props.t('eSIM')}</h2>
                    </div>
                </div>
                <div className="dashboard-account-body">
                    <div className="m-3" style={{ marginTop: '1px' }}>
                        {selectedCountry ? (
                            <div className="dashboard-esim-detail">
                                <div className="dashboard-esim-detail-header">
                                    <h3 className="dashboard-esim-detail-title">{this.props.t('eSIM paketləri')}</h3>
                                    {/* {this.state.isLoading ? <span className="dashboard-esim-detail-loading">Yüklənir...</span> : null} */}
                                </div>

                                <div className="dashboard-esim-detail-top">
                                    <div className="dashboard-esim-detail-country-card" style={{ background: selectedCountry.imageUrl ? `url(${selectedCountry.imageUrl})` : 'linear-gradient(180deg, rgba(138, 158, 177, 0.95) 0%, rgba(171, 192, 209, 0.9) 52%, rgba(185, 205, 219, 0.84) 100%)' }}>
                                        <div className="dashboard-esim-detail-country-card-header">
                                            {/* <span>{selectedCountry.flag}</span> */}
                                            {selectedCountry.flagUrl && String(selectedCountry.flagUrl).indexOf('http') === 0
                                                ? <img src={selectedCountry.flagUrl} alt={selectedCountry.name} width="42" height="34" />
                                                : selectedCountry.flagUrl}
                                            <h4>{selectedCountry.name}</h4>
                                        </div>
                                        <div className="dashboard-esim-detail-country-card-body">
                                            <div className="dashboard-esim-detail-country-card-tags">
                                                {/* {selectedCountry.features.map((feature) => ( */}
                                                <span><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                    <g clip-path="url(#clip0_195_13671)">
                                                        <path d="M5.00016 9.16683C7.30135 9.16683 9.16683 7.30135 9.16683 5.00016C9.16683 2.69898 7.30135 0.833496 5.00016 0.833496C2.69898 0.833496 0.833496 2.69898 0.833496 5.00016C0.833496 7.30135 2.69898 9.16683 5.00016 9.16683Z" stroke="white" stroke-opacity="0.8" stroke-width="1.04167" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M3.3335 5.00016C3.3335 3.4488 3.93026 1.95689 5.00016 0.833496C6.07007 1.95689 6.66683 3.4488 6.66683 5.00016C6.66683 6.55152 6.07007 8.04343 5.00016 9.16683C3.93026 8.04343 3.3335 6.55152 3.3335 5.00016Z" stroke="white" stroke-opacity="0.8" stroke-width="1.04167" stroke-linecap="round" stroke-linejoin="round" />
                                                        <path d="M0.833496 5H9.16683" stroke="white" stroke-opacity="0.8" stroke-width="1.04167" stroke-linecap="round" stroke-linejoin="round" />
                                                    </g>
                                                </svg> {selectedCountry.networkInfo.operators}</span>
                                                <span><svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                                    <path d="M2.0415 7.95817C0.416504 6.33317 0.416504 3.6665 2.0415 2.0415" stroke="white" stroke-opacity="0.8" stroke-width="1.04167" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M3.25 6.75016C2.29167 5.79183 2.29167 4.2085 3.25 3.2085" stroke="white" stroke-opacity="0.8" stroke-width="1.04167" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M4.99984 5.83317C5.46007 5.83317 5.83317 5.46007 5.83317 4.99984C5.83317 4.5396 5.46007 4.1665 4.99984 4.1665C4.5396 4.1665 4.1665 4.5396 4.1665 4.99984C4.1665 5.46007 4.5396 5.83317 4.99984 5.83317Z" stroke="white" stroke-opacity="0.8" stroke-width="1.04167" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M6.75 3.25C7.70833 4.20833 7.70833 5.79167 6.75 6.79167" stroke="white" stroke-opacity="0.8" stroke-width="1.04167" stroke-linecap="round" stroke-linejoin="round" />
                                                    <path d="M7.9585 2.0415C9.5835 3.6665 9.5835 6.2915 7.9585 7.9165" stroke="white" stroke-opacity="0.8" stroke-width="1.04167" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg> {selectedCountry.networkInfo.networkType}</span>
                                                {/* ))} */}
                                            </div>

                                            {selectedCountry.notices.map((notice) => (
                                                <div className="dashboard-esim-detail-notice">
                                                    <p className="mb-2">{notice.severity}</p>
                                                    <p className="mb-1">{notice.title}</p>
                                                    <p>{notice.body}</p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="dashboard-esim-detail-plan-list">
                                        {selectedCountry.plans.map((plan) => (
                                            <button key={plan.id} type="button" className="dashboard-esim-detail-plan-card" onClick={() => this.openOrderPage(plan)}>
                                                <div className="dashboard-esim-detail-plan-card-left">
                                                    <p className="dashboard-esim-detail-plan-card-volume">{plan.volume}</p>
                                                    <div className="dashboard-esim-detail-plan-card-meta">
                                                        <span>{plan.period} {t('day')}</span>
                                                        <span>{plan.networkType}</span>
                                                    </div>
                                                </div>
                                                <div className="dashboard-esim-detail-plan-card-right">
                                                    <p className="dashboard-esim-detail-plan-card-price">{plan.price}</p>
                                                    {plan.popular ? <span className="dashboard-esim-detail-plan-card-tag">• {t('Most popular')}</span> : null}
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <div className="dashboard-esim-detail-related">
                                    <h4>Birdən çox ölkəyə səyahət edirsiniz?</h4>
                                    <p className='dashboard-esim-detail-related-description'>Əhatə edən digər paketlər</p>
                                    <div className="dashboard-esim-detail-related-grid">
                                        {selectedCountry.alsoCoveredBy.map((item) => (
                                            <button className="dashboard-esim-destination-list-card" type="button" onClick={() => this.props.history.push(`/dashboard/services/e-sim/details/${encodeURIComponent(item.code)}`)} key={item.code}>
                                                <div className="dashboard-esim-destination-list-card-left">
                                                    <span className="dashboard-esim-destination-list-card-icon">
                                                        {item.flagUrl && String(item.flagUrl).indexOf('http') === 0
                                                            ? <img src={item.flagUrl} alt={item.name} width="20" height="16" />
                                                            : '🌍'}
                                                    </span>
                                                    <div>
                                                        <p className="dashboard-esim-destination-list-card-title">{item.name}</p>
                                                        <p className="dashboard-esim-destination-list-card-subtitle">{item.countryCount} {t('country')} • {item.price}</p>
                                                    </div>
                                                </div>
                                                <div className="dashboard-esim-detail-related-right">
                                                    {/* <span>{item.includeText}</span> */}
                                                    <span className="dashboard-esim-destination-list-card-arrow">{this.renderChevron()}</span>
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                {visiblecountries.length > 0 && (
                                    <div className="dashboard-esim-detail-related">
                                        <h4 className='mb-3'>{t('Daxil olan ölkələr')}</h4>

                                        {/* <p className='dashboard-esim-detail-related-description'>Əhatə edən digər paketlər</p> */}
                                        <div className="dashboard-esim-detail-country-card-tags">
                                            {visiblecountries.map((item) => (
                                                <span className="tag">
                                                    {item.flagUrl && String(item.flagUrl).indexOf('http') === 0
                                                        ? <img src={item.flagUrl} alt={item.name} width="20" height="16" />
                                                        : '🌍'} {item.name}
                                                </span>
                                            ))}
                                            {!showAllcountries && remainingcountries > 0 ? (
                                                <button type="button" className="tag" onClick={this.togglecountries}>
                                                    +{remainingcountries}
                                                </button>
                                            ) : null}
                                        </div>
                                    </div>)}
                            </div>
                        ) : null}
                    </div>
                </div>
            </>
        );
    }
}

export default translate('translation')(ESIMDetail);